<dk-ticker-card
  titleText="Fırsatlar"
  [data]="data"
  [percentage]="20.3"
  contentClass="opportunities-total"
></dk-ticker-card>
